<template>
  <a-config-provider :locale="locale">
    <div class="demo-app">
      <router-view />
      <AliyunLivePlayerWindow />
      <!-- <div class="map-wrapper">
        <GMap/>
      </div> -->
    </div>
  </a-config-provider>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useMyStore } from './store'
import GMap from '/@/components/GMap.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import AliyunLivePlayerWindow from '/@/components/aliyun-live/AliyunLivePlayerWindow.vue'

export default defineComponent({
  name: 'App',
  components: { GMap, AliyunLivePlayerWindow },

  setup () {
    const store = useMyStore()
    return {
      locale: zhCN
    }
  }
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
